import React from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar, FiClock } from 'react-icons/fi';
import calendarService from '../../../services/calendar';

const formatMaybeTimestamp = (val) => {
  if (val === null || val === undefined) return '';
  if (typeof val === 'number' || (/^\d+$/.test(String(val)))) {
    return calendarService.formatDateTime(val);
  }
  return String(val);
};

const formatDateOnly = (val) => {
  if (val === null || val === undefined) return '';
  const ts = typeof val === 'number' || (/^\d+$/.test(String(val))) ? parseInt(val) : NaN;
  if (!Number.isNaN(ts)) {
    const d = new Date(ts);
    return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
  const d = new Date(val);
  return isNaN(d.getTime()) ? String(val) : d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const formatTimeOnly = (val) => {
  if (val === null || val === undefined) return '';
  const ts = typeof val === 'number' || (/^\d+$/.test(String(val))) ? parseInt(val) : NaN;
  if (!Number.isNaN(ts)) {
    const d = new Date(ts);
    return d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  }
  const d = new Date(val);
  return isNaN(d.getTime()) ? String(val) : d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
};

const PriorityDot = ({ priority }) => {
  const color = calendarService.getPriorityColor(
    Number.isFinite(parseInt(priority)) ? parseInt(priority) : 1
  );
  return (
    <span
      style={{ backgroundColor: color }}
      className="inline-block h-2.5 w-2.5 rounded-full"
    />
  );
};

export default function UpcomingEventsList({ title, desc, data }) {
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <div className="border dark:border-dark-300 w-full border-gray-200 bg-white dark:bg-dark-300 my-3 p-[5px] min-h-[400px] h-full">
      <div className="flex justify-between items-center px-2 py-3">
        <h2 className="m-2 w-full text-black dark:text-darkWhite-300 text-[14px] font-semibold">{title}</h2>
        <div className="underline underline-offset-8 decoration-dotted m-2 text-red-600 dark:text-darkPurple text-[13px] font-semibold whitespace-nowrap">
          <Link to="/calendar">Tümünü Gör</Link>
        </div>
      </div>

      {!hasData ? (
        <div className="flex flex-col items-center justify-center py-8">
          <div className="mb-4">
            <img 
              src="/assets/dashboard/yaklasanE.svg" 
              alt="Etkinlik yok" 
              className="w-32 h-32 dark:hidden opacity-70"
            />
            <img 
              src="/assets/dashboard/yaklasanedark.svg" 
              alt="Etkinlik yok" 
              className="w-32 h-32 hidden dark:block opacity-70"
            />
          </div>
          <p className="opacity-60 text-center w-[300px] text-sm">{desc}</p>
        </div>
      ) : (
        <ul className="divide-y divide-gray-100/60 dark:divide-dark-200/30">
          {data.slice(0, 6).map((item, idx) => {
            const title = item.c_title || item.title || 'Etkinlik';
            const desc = item.c_desc || item.description || '';
            const startRaw = item.c_start ?? item.start;
            const endRaw = item.c_end ?? item.end;
            const start = formatMaybeTimestamp(startRaw);
            const end = formatMaybeTimestamp(endRaw);
            const startDateStr = formatDateOnly(startRaw);
            const startTimeStr = formatTimeOnly(startRaw);
            const endDateStr = formatDateOnly(endRaw);
            const endTimeStr = formatTimeOnly(endRaw);
            const priority = item.c_priority ?? item.priority ?? 1;

            return (
              <li key={idx} className="group">
                <div className="flex items-center justify-between gap-4 px-4 py-3 rounded-lg transition-colors">
                  {/* Sol kısım: öncelik noktası + başlık + kısa açıklama */}
                  <div className="flex items-start gap-3 min-w-0 flex-1">
                    <PriorityDot priority={priority} />
                    <div className="min-w-0">
                      <p className="text-[14px] font-medium text-[#283252] dark:text-[#AAAAB3] truncate">{title}</p>
                      {desc ? (
                        <p className="text-[12px] text-[#8b8fa5] dark:text-[#8b8fa5] truncate">{desc}</p>
                      ) : null}
                    </div>
                  </div>
                  {/* Sağ kısım: inside.jsx ile aynı tarih-saat bloğu */}
                  <div className="flex-end">
                    <div className="dark-inverted text-[12px]">
                      <div className="flex pb-1 items-center gap-1">
                        <FiCalendar /> <p>{endDateStr}</p>
                      </div>
                      <div className="flex items-center gap-1">
                        <FiClock /> <p>{startTimeStr}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}


